import React from "react";
import { Navigate } from "react-router-dom";
import Loading from "react-fullscreen-loading";
import { useAuth } from "./AuthContext";

// Guards the screens that belong to the PERSON rather than to a portal — the
// "my account" pages. Any signed-in session passes, whichever portal it is, so
// there is deliberately no userType branch here: there is nothing to branch on.
// UserRoute, AdminRoute and ResellerRoute all exist to bounce the wrong portal
// somewhere useful; this one has no wrong portal.
//
// The page still has to pick its own chrome — admin sidebar vs. user sidebar —
// off userType. See Pages/User/Profile/Profile.js.
//
// Mirrors the backend, where /api/profile is mounted outside the /user, /admin
// and /reseller trees beside /api/table_preferences for exactly this reason.
// And as with every guard here, this is presentation only: the server re-checks
// each request, and every /api/profile handler addresses the caller's own row
// from the verified token rather than an id off the request.
export const AuthedRoute = ({ children }) => {
  const { status } = useAuth();

  if (status === "loading") {
    return <Loading loading={true} background="#fff" loaderColor="#883484" />;
  }
  if (status === "anon") {
    return <Navigate to="/signin" replace />;
  }
  return children;
};
